import { createTheme as p, alpha as d } from "@mui/material/styles";
import { defaultBorderRadius as u, baseTypography as m, basePalette as n, customTypography as a, accentColors as c } from "@coast/utils";
function s(o, t = {}) {
  const e = t.mode ?? "light", i = p({
    palette: {
      mode: e
    }
  }).palette, r = p({
    palette: {
      mode: e,
      ...n,
      ...t,
      background: {
        ...n.background,
        ...t.background
      },
      text: {
        ...n.text,
        ...t.text
      },
      secondary: {
        ...n.secondary,
        ...t.secondary
      },
      primary: {
        ...n.primary,
        ...t.primary
      },
      action: {
        ...i.action,
        ...t.action
      },
      info: {
        ...i.info,
        ...t.info
      }
    },
    typography: m,
    shape: {
      borderRadius: u
    }
  }), { augmentColor: l } = r.palette;
  return p(r, {
    palette: {
      accentOne: l({ color: c.accentOne }),
      accentTwo: l({ color: c.accentTwo }),
      accentThree: l({ color: c.accentThree }),
      backgroundSecondary: l({
        color: c.backgroundSecondary
      })
    },
    typography: {
      heroTitle: {
        fontFamily: a.heroTitle.fontFamily,
        fontWeight: a.heroTitle.fontWeight,
        fontSize: a.heroTitle.fontSizeMobile,
        lineHeight: a.heroTitle.lineHeightMobile,
        [r.breakpoints.up("md")]: {
          fontSize: a.heroTitle.fontSizeDesktop,
          lineHeight: a.heroTitle.lineHeightDesktop
        }
      },
      sectionTitle: a.sectionTitle,
      eyebrow: a.eyebrow
    },
    components: {
      MuiTypography: {
        defaultProps: {
          variantMapping: {
            heroTitle: "h1",
            sectionTitle: "h2",
            eyebrow: "span"
          }
        }
      },
      // Browser translation can rewrite MUI's outline/legend DOM and trigger
      // React NotFoundError crashes when the field rerenders.
      MuiFormControl: {
        defaultProps: {
          translate: "no"
        }
      },
      MuiInputLabel: {
        defaultProps: {
          translate: "no"
        }
      },
      MuiFormLabel: {
        defaultProps: {
          translate: "no"
        }
      },
      MuiButton: {
        styleOverrides: {
          contained: {
            backgroundColor: r.palette.primary.main,
            color: r.palette.primary.contrastText,
            "&:hover": {
              backgroundColor: r.palette.secondary.main,
              color: r.palette.secondary.contrastText
            },
            "&:visited": {
              backgroundColor: r.palette.primary.main,
              color: r.palette.primary.contrastText
            },
            "&:visited:hover": {
              backgroundColor: r.palette.secondary.main,
              color: r.palette.secondary.contrastText
            }
          }
        }
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            borderColor: r.palette.divider
          }
        }
      },
      MuiDataGrid: {
        styleOverrides: {
          root: {
            "--DataGrid-containerBackground": r.palette.background.default
          },
          columnHeaders: {
            backgroundColor: r.palette.background.default
          },
          footerContainer: {
            backgroundColor: r.palette.background.default
          }
        }
      }
    },
    coastline: o
  });
}
function b(o) {
  return s(o);
}
function y(o) {
  return o === "dark" ? {
    mode: o,
    primary: {
      main: "#3B82F6",
      light: "#60A5FA",
      dark: "#2563EB",
      contrastText: "#FFFFFF"
    },
    secondary: {
      main: "#3B82F6",
      light: "#60A5FA",
      dark: "#2563EB",
      contrastText: "#FFFFFF"
    },
    background: {
      default: "#0F172A",
      paper: "#111827"
    },
    text: {
      primary: "#F9FAFB",
      secondary: "#CBD5E1"
    },
    divider: "#334155",
    action: {
      hover: "#1E293B",
      selected: "#1E3A8A"
    },
    info: {
      main: "#3B82F6",
      light: "#60A5FA",
      dark: "#2563EB",
      contrastText: "#FFFFFF"
    }
  } : {
    mode: o,
    primary: {
      main: "#1D4ED8",
      light: "#3B82F6",
      dark: "#1E40AF",
      contrastText: "#FFFFFF"
    },
    secondary: {
      main: "#1D4ED8",
      light: "#3B82F6",
      dark: "#1E40AF",
      contrastText: "#FFFFFF"
    },
    background: {
      default: "#F9FAFB",
      paper: "#FFFFFF"
    },
    text: {
      primary: "#111827",
      secondary: "#4B5563"
    },
    divider: "#E5E7EB",
    action: {
      hover: "#F3F4F6",
      selected: "#EFF6FF"
    },
    info: {
      main: "#1D4ED8",
      light: "#3B82F6",
      dark: "#1E40AF",
      contrastText: "#FFFFFF"
    }
  };
}
function h(o, t = "light") {
  const e = s(
    o,
    y(t)
  ), i = (r) => ({
    backgroundColor: d(r.main, 0.12),
    border: `1px solid ${d(r.main, 0.28)}`,
    color: e.palette.text.primary,
    "& .MuiAlert-icon": {
      color: r.light ?? r.main
    }
  });
  return p(e, {
    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            backgroundImage: "none",
            color: e.palette.text.primary
          }
        }
      },
      MuiDialog: {
        styleOverrides: {
          paper: {
            backgroundColor: e.palette.background.paper,
            color: e.palette.text.primary
          }
        }
      },
      MuiDialogContentText: {
        styleOverrides: {
          root: {
            color: e.palette.text.secondary
          }
        }
      },
      MuiListSubheader: {
        styleOverrides: {
          root: {
            backgroundColor: e.palette.background.paper,
            color: e.palette.text.secondary,
            fontWeight: 600
          }
        }
      },
      MuiMenu: {
        styleOverrides: {
          paper: {
            backgroundColor: e.palette.background.paper,
            color: e.palette.text.primary,
            border: `1px solid ${e.palette.divider}`,
            backgroundImage: "none"
          }
        }
      },
      MuiMenuItem: {
        styleOverrides: {
          root: {
            color: e.palette.text.primary,
            "&:hover": {
              backgroundColor: e.palette.action.hover
            },
            "&.Mui-selected": {
              backgroundColor: e.palette.action.selected
            },
            "&.Mui-selected:hover": {
              backgroundColor: e.palette.action.selected
            }
          }
        }
      },
      MuiListItemText: {
        styleOverrides: {
          primary: {
            color: "inherit"
          }
        }
      },
      MuiAlert: {
        styleOverrides: {
          standardSuccess: i(
            e.palette.success
          ),
          standardInfo: i(e.palette.info),
          standardWarning: i(
            e.palette.warning
          ),
          standardError: i(e.palette.error)
        }
      },
      MuiButton: {
        styleOverrides: {
          contained: {
            backgroundColor: e.palette.primary.main,
            color: e.palette.primary.contrastText,
            "&:hover": {
              backgroundColor: e.palette.primary.dark,
              color: e.palette.primary.contrastText
            },
            "&:visited": {
              backgroundColor: e.palette.primary.main,
              color: e.palette.primary.contrastText
            },
            "&:visited:hover": {
              backgroundColor: e.palette.primary.dark,
              color: e.palette.primary.contrastText
            }
          },
          outlined: {
            borderColor: e.palette.primary.main,
            color: e.palette.primary.main,
            "&:hover": {
              borderColor: e.palette.primary.main,
              color: e.palette.primary.light,
              backgroundColor: d(e.palette.primary.main, 0.08)
            },
            "&:visited": {
              borderColor: e.palette.primary.main,
              color: e.palette.primary.main
            },
            "&:visited:hover": {
              borderColor: e.palette.primary.main,
              color: e.palette.primary.light,
              backgroundColor: d(e.palette.primary.main, 0.08)
            }
          }
        }
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            borderColor: e.palette.divider
          },
          head: {
            backgroundColor: e.palette.background.default,
            color: e.palette.text.primary,
            fontWeight: 600,
            "&:not(:last-of-type)": {
              borderRight: `1px solid ${e.palette.divider}`
            }
          }
        }
      },
      MuiDataGrid: {
        styleOverrides: {
          root: {
            border: 0,
            backgroundColor: "transparent",
            "--DataGrid-containerBackground": e.palette.background.paper
          },
          columnHeaders: {
            backgroundColor: e.palette.background.default,
            borderBottom: `1px solid ${e.palette.divider}`
          },
          columnHeaderTitle: {
            color: e.palette.text.primary,
            fontWeight: 600
          },
          cell: {
            borderColor: e.palette.divider
          },
          row: {
            "&:hover": {
              backgroundColor: e.palette.action.hover
            }
          },
          footerContainer: {
            backgroundColor: e.palette.background.paper,
            borderTop: `1px solid ${e.palette.divider}`
          }
        }
      }
    }
  });
}
export {
  b as a,
  h as c
};
